export default "__VITE_ASSET__BuMPZ1VN__"